import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getFontSize, getLineHeight } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getGradient } from "./auth-service-tools211.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { polymorphicFactory } from "./auth-service-tools249.js";
import classes from "./auth-service-tools418.js";

function getTextTruncate(truncate) {
  if (truncate === "start") {
    return "start";
  }

  if (truncate === "end" || truncate) {
    return "end";
  }

  return void 0;
}

const defaultProps = {
  inherit: false
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    variant,
    lineClamp,
    gradient,
    size,
    color
  } = _ref;
  return {
    root: {
      "--text-fz": getFontSize(size),
      "--text-lh": getLineHeight(size),
      "--text-gradient": variant === "gradient" ? getGradient(gradient, theme) : void 0,
      "--text-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
      "--text-color": color ? getThemeColor(color, theme) : void 0
    }
  };
});
const Text = polymorphicFactory((_props, ref) => {
  const props = useProps("Text", defaultProps, _props);
  const {
    lineClamp,
    truncate,
    inline,
    inherit,
    gradient,
    span,
    __staticSelector,
    vars,
    className,
    style,
    classNames,
    styles,
    unstyled,
    variant,
    mod,
    size,
    ...others
  } = props;
  const getStyles = useStyles({
    name: ["Text", __staticSelector],
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...getStyles("root", {
      focusable: true
    }),
    ref,
    component: span ? "span" : "p",
    variant,
    mod: [{
      "data-truncate": getTextTruncate(truncate),
      "data-line-clamp": typeof lineClamp === "number",
      "data-inline": inline,
      "data-inherit": inherit
    }, mod],
    size,
    ...others
  });
});
Text.classes = classes;
Text.displayName = "@mantine/core/Text";
export { Text };